import shajs from "sha.js";
import * as qz from "qz-tray";

export function printSell(data) {
  qz.api.setPromiseType(function promise(resolver) {
    return new Promise(resolver);
  });
  qz.api.setSha256Type(function (data) {
    return shajs("sha256").update(data).digest("hex");
  });
  qz.websocket
    .connect()
    .then(function () {
      return qz.printers.find("POS-80 (copy 1)"); // Pass the printer name into the next Promise
    })
    .then(function (printer) {
      var config = qz.configs.create(printer); // Create a default config for the found printer
      var data = [
        {
          type: "image",
          data: "srccommonhelpersANails.png",
        },
      ]; // Raw ZPL
      const qr = "https://qz.io";
      const dots = "\x09";
      const size1 = String.fromCharCode(qr.length + 3);
      const size0 = "\x00"; // Always 0 unless qr > 256 characters
      var data2 = [
        // { type: 'raw', format: 'image', data: 'assets/img/image_sample_bw.png', options: { language: "ESCPOS", dotDensity: 'double' } },
        "\x1B" + "\x40", // init
        "\x1B" + "\x61" + "\x31", // center align
        // '\x1D' + '\x21' + '\x11', // double font
        "Angel´s Nails Saloon" + "\x0A",
        "\x1B" + "\x4D" + "\x31", // small font
        "\x0A", // line break
        "Angel´s Nails Barrenechea" + "\x0A",
        "Angel´s Nails Barrenechea" + "\x0A",
        "RUC:  20602634257" + "\x0A",
        "Avenida Galvez Barrenechea 1006 Corpac San Isidro" + "\x0A",
        "Teléfono: 4750532" + "\x0A",
        // '\x1B' + '\x4D' + '\x31',
        "----------------------------------------------------------------" +
          "\x0A",
        "Boleta / Factura de Venta Electrónica" + "\x0A",
        "BO57-NUMBER" + "\x0A",
        "\x0A", // line break
        "\x1B" + "\x61" + "\x30", // left align
        "Fecha de emision:          " + Date.now().toString() + "\x0A",
        "Cajero:                    " + "Super Admin" + "\x0A",
        "----------------------------------------------------------------" +
          "\x0A",

        "\x1B" + "\x61" + "\x30", // left align
        "Doc. Identidad:            " + "DNI" + "\x0A",
        "Numero:                    " + "666 Beast" + "\x0A",
        "Cliente:                   " + "Alexander Pepi Tercero, Pepi" + "\x0A",
        "----------------------------------------------------------------" +
          "\x0A",
        "Articulo                           Cant      P. Unit     Total" +
          "\x0A",
        "----------------------------------------------------------------" +
          "\x0A",
        "Pepi Cepillo                        1        300         300" + "\x0A",
        "Monitor Ulices                      1        300         300" + "\x0A",
        "Galletas Senior                     1        300         300" + "\x0A",
        "Esternocleidomastoideo Europeo      1        300         300" + "\x0A",
        "Pepi Cepillo                        1        300         300" + "\x0A",
        "Monitor Ulices                      1        300         300" + "\x0A",
        "Galletas Senior                     1        300         300" + "\x0A",
        "Esternocleidomastoideo Europeo      1        300         300" + "\x0A",
        "----------------------------------------------------------------" +
          "\x0A",
        "\x0A", // line break

        "\x1B" + "\x61" + "\x32", // right align
        "OP. Gravada (S/.):                           " + "1968.00" + "\x0A",
        "IGV (S/.):                                   " + "432.00" + "\x0A",
        "Total Venta (S/.):                           " + "2400.00" + "\x0A",

        "\x0A", // line break                       // line break
        "\x0A",
        "\x1B" + "\x61" + "\x30", // left align
        "SON PEPICIENTOS CON 66/100 SOLES" + "\x0A",
        "----------------------------------------------------------------" +
          "\x0A",
        "\x1B" + "\x61" + "\x31", // center align
        "\x1B" + "\x4D" + "\x31",
        "POR FAVOR EXIJA SU BOLETA O FACTURA" + "\x0A",
        "QR" + "\x0A",
        // <!-- BEGIN QR DATA -->
        "\x1D" +
          "\x28" +
          "\x6B" +
          "\x04" +
          "\x00" +
          "\x31" +
          "\x41" +
          "\x32" +
          "\x00", // <Function 165> select the model (model 2 is widely supported)
        "\x1D" + "\x28" + "\x6B" + "\x03" + "\x00" + "\x31" + "\x43" + dots, // <Function 167> set the size of the module
        "\x1D" + "\x28" + "\x6B" + "\x03" + "\x00" + "\x31" + "\x45" + "\x30", // <Function 169> select level of error correction (48,49,50,51) printer-dependent
        "\x1D" +
          "\x28" +
          "\x6B" +
          size1 +
          size0 +
          "\x31" +
          "\x50" +
          "\x30" +
          qr, // <Function 080> send your data (testing 123) to the image storage area in the printer
        "\x1D" + "\x28" + "\x6B" + "\x03" + "\x00" + "\x31" + "\x51" + "\x30", // <Function 081> print the symbol data in the symbol storage area
        "\x1D" + "\x28" + "\x6B" + "\x03" + "\x00" + "\x31" + "\x52" + "\x30", // <Function 082> Transmit the size information of the symbol data in the symbol storage area
        // <!-- END QR DATA -->
        "\x0A" + "\x0A",
        // 'New York, NY' + '\x0A' + '\x0A' + '\x0A' + '\x0A' + '\x0A' + '\x0A',               // more line feeds and text to see if we messed up the QR Code syntax
        "Autorizado mediante resolución Nro. 0340050010017/SUNAT" + "\x0A",
        "Para consultar el comprobante ingresar a" + "\x0A",
        "www.angelsnails.com.pe" + "\x0A",
        "Representación impresa del Comprobante Electrónico." + "\x0A",
        "\x1B" + "\x61" + "\x31", // center align
        // 'Transaction # 123456 Register: 3' + '\x0A',
        // '\x0A',
        // '\x0A',
        // '\x0A',
        // '\x1B' + '\x61' + '\x30', // left align
        // 'Baklava (Qty 4)       9.00' + '\x1B' + '\x74' + '\x13' + '\xAA', //print special char symbol after numeric
        // '\x0A',
        // 'XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX' + '\x0A',
        // '\x1B' + '\x45' + '\x0D', // bold on
        // 'Here\'s some bold text!',
        // '\x0A',
        // '\x1B' + '\x45' + '\x0A', // bold off
        // '\x1D' + '\x21' + '\x11', // double font size
        // 'Here\'s large text!',
        // 'Somebody once told me',
        // '\x0A',
        // '\x1D' + '\x21' + '\x00', // standard font size
        // '\x1B' + '\x61' + '\x32', // right align
        // '\x1B' + '\x21' + '\x30', // em mode on
        // 'DRINK ME',
        // '\x1B' + '\x21' + '\x0A' + '\x1B' + '\x45' + '\x0A', // em mode off
        // '\x0A' + '\x0A',
        // '\x1B' + '\x61' + '\x30', // left align
        // '------------------------------------------' + '\x0A',
        // '\x1B' + '\x4D' + '\x31', // small text
        // 'EAT ME' + '\x0A',
        // '\x1B' + '\x4D' + '\x30', // normal text
        // '------------------------------------------' + '\x0A',
        // 'normal text',
        "\x1B" + "\x61" + "\x30", // left align
        "\x0A" + "\x0A" + "\x0A" + "\x0A" + "\x0A" + "\x0A" + "\x0A",
        "\x1B" + "\x69", // cut paper (old syntax)
        // '\x1D' + '\x56'  + '\x00' // full cut (new syntax)
        // '\x1D' + '\x56'  + '\x30' // full cut (new syntax)
        // '\x1D' + '\x56'  + '\x01' // partial cut (new syntax)
        // '\x1D' + '\x56'  + '\x31' // partial cut (new syntax)
        "\x10" + "\x14" + "\x01" + "\x00" + "\x05", // Generate Pulse to kick-out cash drawer**
        // **for legacy drawer cable CD-005A.  Research before using.
        // see also http://keyhut.com/popopen4.htm
      ];
      // qz.print(config, data);
      qz.print(config, data2);
      return qz.print(config, data2);
    })
    // .then(function() {
    //   return qz.print(config, data2);
    // })
    .then(function () {
      qz.websocket.disconnect();
      return;
    })
    .catch(function (e) {
      qz.websocket.disconnect();
    });
}



// WEBPACK FOOTER //
// ./src/common/helpers/print.js